import { CommonModule } from '@angular/common';
import { ChangeDetectorRef, Component, HostListener, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { PrivateFolderController } from '@commoncore/controller/PrivateFolderController';
import { SessionStorageProps } from '@commoncore/enums/sessionStorageProps';
import { GlobalService } from '@commoncore/services/global.service';
import { AppEvents, EventsList } from '@commoncore/utils/app-events';
import { ENV_CONSTANTS } from '@env-properties/environment';
import { AllFilesController } from '@mainrepo/app/core/controller/AllFilesController';

@Component({
  standalone:true,
  selector: 'common-private-folder-password',
  templateUrl: './private-folder-password.component.html',
  styleUrls: ['./private-folder-password.component.scss'],
  imports:[CommonModule]
})

export class PrivateFolderPasswordComponent implements OnInit {

  controller: any = null;
  implRef: any;
  private router:any;
  public universalService:any;
  pfcontroller: any;
  loggerService: any;
  passwordError:any="";
  enableButton:boolean=false;
  nextOperation:any;
  showPrivateFoldePasswordModal:boolean = false;
  sessionStorageService: any;
  shareAccessService: any;
  lastMouseMovementTime : any;
  localStorageService:any;
  folderKeyInRoute : any;
  cleverTapEventsService:any;
  show:boolean = false;
  listService:any;

  constructor(public globalService: GlobalService,private  changeDetector:ChangeDetectorRef,private activatedRoute:ActivatedRoute) {
    this.setEnvObjects();
  }

  @HostListener('document:keydown', ['$event'])
  onKeyDownHandler(event: KeyboardEvent) {
    if (event.key === "Escape" && this.showPrivateFoldePasswordModal) {
      this.closePopUp();
    } else if (event.key === "Enter" && this.enableButton && this.showPrivateFoldePasswordModal){
      this.unlock( (<HTMLInputElement>document.getElementById("pfpassword")))
    }
  }
  
  ngOnInit() {
    this.pfcontroller=PrivateFolderController.getInstance(this.globalService);
    this.controller=AllFilesController.getInstance(this.globalService);

    this.implRef =  this.pfcontroller.pfImpl;
    this.pfcontroller.setEnvObjects(this.globalService);
    this.controller.setEnvObjects(this.globalService);
    let classRef = this;
    AppEvents.globalObservable.subscribe(event => {
      if(event["nextOperation"] !=undefined) {
        classRef.nextOperation = event["nextOperation"];
      }
      if(event["showPrivateFoldePassword"]){
        this.folderKeyInRoute = event["privateFolderObjectKey"];
        classRef.showPrivateFoldePasswordModal = true;
        classRef.initilizeFileProps();
        classRef.changeDetector.detectChanges()
      }else if(event["checkIfPrivateFolderShouldActivate"]){
        classRef.showPrivateFoldePasswordModal = false;
        classRef.checkIfPPFShouldActivate();
      } else if(event["closeAll"] || event["showPrivateFoldePassword"]== false){
        classRef.showPrivateFoldePasswordModal = false;
        classRef.changeDetector.detectChanges()
      }else if(event["clearSession"]){
        classRef.sessionStorageService.removeSessionProperty(SessionStorageProps.PRIVATE_FOLDER_PASSWORD_TIME);
        classRef.changeDetector.detectChanges()
      }
    })
  }

  initilizeFileProps(){
    this.show = false;
    this.implRef.passwordError = "";
    this.enableButton = false;
    var el = (<HTMLInputElement>document.getElementById('pfpassword'));
    if(el != undefined){
                el.value = "";
    }
    setTimeout(()=>{
      $(document).off('focusin.modal');
      let temp = <HTMLInputElement>document.getElementById("pfpassword");
      let len = temp.value.length;
      (<HTMLInputElement>document.getElementById("pfpassword")).focus();
      temp.setSelectionRange(len, len);
    },800)
  }

  setEnvObjects(){
    this.router = this.globalService.getRouterRef();
    this.loggerService = this.globalService.getLoggerServiceRef();
    this.universalService = this.globalService.getUniversalServiceRef();
    this.listService = this.globalService.getListServiceRef();
    this.sessionStorageService = this.globalService.getSessionStorageSvcRef();
    this.shareAccessService = this.globalService.getShareAccessServiceRef();
    this.localStorageService = this.globalService.getLocalStorageSvcRef();
    this.cleverTapEventsService =  this.globalService.getCleverTapEventsvc();
  }

  validateEmptyText(pwd){
    this.passwordError = "";
    if(pwd.value != "") {
      this.enableButton = true;
    } else {
      this.enableButton = false;
      pwd.focus();
    }
  }

  

  closePopUp(){
    this.listService.deSelectAll(null);
    this.universalService.disableModalBackdrop();
    if(!this.universalService.openFolderContent && this.universalService.foldersArray.length == 0){
      this.universalService.emptyTab = true;
      this.universalService.emptyShared = true;
    }
    if(window.location.href.includes("privatefolder")){
      if (confirm("You will be redirected to JioAICloud MyFiles page")) {
        AppEvents.globalObservable.next({showPrivateFoldePassword: false})
        this.router.navigate(['allfiles']);
      } else {
        return
      }
    }else{
      AppEvents.globalObservable.next({showPrivateFoldePassword: false})
      AppEvents.globalObservable.next({nextOperation : false});
    }

  }

  async unlock(pwd){
    let response = await this.pfcontroller.unlockPF(pwd.value);
    
    if(!this.router.url.includes('privatefolder')) {
      this.universalService.isPrivateFolderTokenRequired = true;
    }
    if(response["validation"]){
      
      AppEvents.globalObservable.next({showPrivateFoldePassword:false});
      this.universalService.showLoader = false;
      this.universalService.disableModalBackdrop();
      if(this.nextOperation && this.nextOperation['initiateMoveToPrivateFolder']) {
        AppEvents.optionSelected.next({initiateMoveToPrivateFolder: true});
        this.nextOperation = undefined;
      } else if(this.nextOperation && this.nextOperation["deletePF"]) {
        this.universalService.showLoader = true;
        var result = await this.pfcontroller.disablePrivateFolder();
        this.nextOperation = undefined;
        this.cleverTapEventsService.deletePfSucc();
        console.log("deleted PF",result);
      } else {
          if(this.universalService.openFolderContent && this.folderKeyInRoute){
            this.router.navigate(['/privatefolder',this.folderKeyInRoute]);
          }else{
            this.router.navigate(['/privatefolder']);
          }
      }
    }
    console.log("pwd is::",response);
    setTimeout(()=>{
      AppEvents.emit(EventsList.EXPAND_SIDEBAR_MORE_MENU, 'PrivateFolder');
    },300)
  }

  getAllFilesAndFolders(){
    this.controller.getAllFilesAndFolders();
  }


  checkIfPPFShouldActivate(){
    let currentTme = new Date().getTime();//current time
    let lastPPFTime = this.sessionStorageService.getPrivateFolderPasswordTime();
    let time = lastPPFTime ? lastPPFTime : currentTme;
    let timeDifference = currentTme - time;
    let passedTime = this.universalService.msToTime(timeDifference);
    this.universalService.cutCopiedFilesWithKeyboard = [];
    console.log(" PPF sessiontime::",lastPPFTime);
    if(lastPPFTime == null || (passedTime.minute >= ENV_CONSTANTS["constants"]["Interval_PPF"] && !this.router.url.includes("/privatefolder"))){
      AppEvents.globalObservable.next({showPrivateFoldePassword:true});
    }else{
      this.universalService.setAnimationStatus('PrivateFolder');
      this.universalService.currentTab = 'PrivateFolder';
      this.universalService.selectedTab = "PrivateFolder"
      this.universalService.headingTitle.set("Private Folder");
      if(this.universalService.mobileSelectedObj.length == 0 && this.universalService.foldersArray.length == 0){
        this.universalService.emptyTab = true;
      }
      this.router.navigate(['privatefolder']);
    }
    
 }

 showHidePaasword() {
    
  let inputEl = document.getElementById("pfpassword") as any ; 
  if (inputEl.type === 'password') {
    inputEl.type="text"
    this.show = true;
  } else {
    inputEl.type = 'password';
    this.show = false;
  }
}

 


  

}


